import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {floorThumbnail} from "../../../kvComponent/core/assets";

import {IntermediatePart} from "../intermediatePart";
import CenterIsland from "./centerIsland";
import {METADATA} from "../constants";

export default class Floor extends Part {
  static id = 'Floor';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.partId = 'parent_floor';
    this.menuType = PartMenuType.Complex;
    this.partName = 'Floor';
    this.translateId = "visualizer.kitchen.kitchen_floor";
    this.partThumbnail = floorThumbnail;
    this.relatedGroupNames = ["Floor"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Flor":
      case "Floor":
        relatedItemName = "floorBody";
        RelatedItemClass = FloorBody;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

}

class FloorBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'kitchen_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.kitchen.kitchen_floor";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["CIShape"]) {
      // if floor has no metadata CIShape and island has no metadata CIShape - just show without the meta
      dbFeature.metaData["CIShape"] = METADATA.FloorWithIsland
    }
    return super.load_(dbFeature, new FloorBody());
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const layout = this.getParent().layout;
    const centerIslandParent = layout.parts[CenterIsland.id];
    if (centerIslandParent && centerIslandParent.cabinet && (layout.type !== 4)) {
      if (centerIslandParent.cabinet.disabled) {
        conditions.push({
          propName: "CIShape",
          propValue: "noCI"
        })
      } else if (centerIslandParent.cabinet.activeFeature && centerIslandParent.cabinet.activeFeature.metaData["CIShape"]) {
        conditions.push({
          propName: "CIShape",
          propValue: centerIslandParent.cabinet.activeFeature.metaData["CIShape"][0]
        })
      } else {
        conditions.push({
          propName: "CIShape",
          propValue: METADATA.FloorWithIsland
        })
      }
    }
    // console.log("floor conditions", conditions);
    return conditions
  }

}


